import { ActionsMenuRenderer } from '@genesislcap/grid-pro';
import { html } from '@microsoft/fast-element';
/**
 * @tagname %%prefix%%-grid-pro-actions-menu-renderer
 */
export class ZeroAgActionsMenuRenderer extends ActionsMenuRenderer {
}
/**
 * The Zero Ag Actions Menu Renderer
 *
 * @public
 * @remarks
 * HTML Element: \<zero-grid-pro-actions-menu-renderer\>
 */
export const zeroAgActionsMenuRenderer = ZeroAgActionsMenuRenderer.compose({
    baseName: 'grid-pro-actions-menu-renderer',
    template: html `
    <zero-actions-menu
      name="${(x) => x.params.headerName}"
      :definition=${(x) => x.params}
    ></zero-actions-menu>
  `,
});
